/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scope_MineInputs */

const cs_scope_mine = /** @type {(inputs: Scope_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje`)
};

const en_scope_mine = /** @type {(inputs: Scope_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine`)
};

/**
* | output |
* | --- |
* | "Mine" |
*
* @param {Scope_MineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const scope_mine = /** @type {((inputs?: Scope_MineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scope_MineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scope_mine(inputs)
	return cs_scope_mine(inputs)
});